import { enumFilter } from "@/utils/filters";

const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  token: (state) => state.user.token,
  name: (state) => {
    return enumFilter("role_type", state.user.roles[0] || "admin");
  },
  username: (state) => state.user.username,
  regions: (state) => state.user.regions,
  regionsName: (state) => state.user.regionsName,
  fullName: (state) => state.user.name,
  firstName: (state) => state.user.firstName,
  lastName: (state) => state.user.lastName,
  passwordExpiredAt: (state) => state.user.passwordExpiredAt,
  daysBeforePasswordExpires: (state) => state.user.daysBeforePasswordExpires,
  mustChangePassword: (state) => state.user.mustChangePassword,
  // mediaUrl: (state) => state.user.mediaUrl,
  mediaUrl: () => process.env.VUE_APP_BASE_API + "/media/",
  // siteUrl: (state) => state.user.siteUrl,
  siteUrl: () => process.env.VUE_APP_SITE_URL,
  roles: (state) => state.user.roles,
  // roles: () => ["admin"],
  permission_routes: (state) => state.permission.routes,
  locations: (state) => state.locations.locations,
  pollingToken: (state) => state.polling.token,
};
export default getters;
